import { isZero } from 'core/utils/number'

import { isEmpty, isNotEmpty, isString } from '../utils/string'
import { type StopType } from './StopType'

const DEFAULT_STOPS_COUNT = 2

export type Stop = {
  address?: string
  city: string
  country?: string
  date?: string
  latitude?: string
  longitude?: string
  state: string
  zipCode?: string
}

export type IndexedStop = Stop & {
  stopIndex: number
}

export function getDelivery(stops: Array<Stop>): Stop {
  return stops[stops.length - 1]
}

export function getPickup(stops: Array<Stop>): Stop {
  return stops[0]
}

export function getStopType(stopIndex: IndexedStop | number, stops: Array<Stop>): StopType {
  const isPickup = isPickupStop(stopIndex)
  const isDelivery = isDeliveryStop(stopIndex, stops)

  if (isPickup) {
    return 'pickup'
  } else if (isDelivery) {
    return 'delivery'
  } else {
    return 'stop'
  }
}

export function hasAddress({ address }: Stop): boolean {
  return isString(address) && isNotEmpty(address)
}

export function hasCoordinates({ latitude, longitude }: Stop) {
  const hasLatitude = !isEmpty(latitude || '') && !isZero(Number(latitude))
  const hasLongitude = !isEmpty(longitude || '') && !isZero(Number(longitude))

  return hasLatitude && hasLongitude
}

export function isDeliveryStop(stopIndex: number | IndexedStop, stops: Array<Stop>): boolean {
  const index = typeof stopIndex === 'number' ? stopIndex : stopIndex.stopIndex
  return index === stops.length - 1
}

export function isMultiStop(stopCount: number) {
  return stopCount > DEFAULT_STOPS_COUNT
}

export function isPickupStop(stopIndex: number | IndexedStop): boolean {
  const index = typeof stopIndex === 'number' ? stopIndex : stopIndex.stopIndex
  return index === 0
}
